import { stringifyUrl } from "query-string";
import { IApiResourceResponse } from "../../@typings/client";
import { ParentProfileInfo } from "../typings/Profiles";
import { UsersLoader } from "./UsersLoader";
import { ProfilesQuery } from "./ProfilesApi";

export class ProfilesParentsApi {
  public static updateParentProfile(
    id: string,
    data: IApiResourceResponse<ParentProfileInfo>,
    query: ProfilesQuery = {}
  ) {
    const url = stringifyUrl({ url: `/users_profiles_parents/${id}`, query }, { arrayFormat: "comma" });
    return UsersLoader.patch({ url, data });
  }
}
